import { render, staticRenderFns } from "./Draws.vue?vue&type=template&id=e97ea21c&scoped=true&"
import script from "./Draws.vue?vue&type=script&lang=js&"
export * from "./Draws.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/static-pages/draws.scss?vue&type=style&index=0&id=e97ea21c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97ea21c",
  null
  
)

export default component.exports